<div class="h-[95dvh] w-[95dvw] max-w-[1200px] overflow-hidden">
  <div class="flex h-full w-full flex-col p-6">
    <div class="mb-4 flex justify-center gap-4 border-b border-gray-100 pb-4">
      <h2 class="flex-1">{{ 'chatMessages.smartSearch.modal.headline' | transloco }}</h2>
      <p-button severity="contrast" icon="pi pi-times" size="small" [aria-label]="'global.close' | transloco" (click)="close?.()" />
    </div>
    <div class="flex-1 overflow-auto">
      <!-- Start scroll content -->
      <div class="relative">
        <textarea
          pTextarea
          #chatInput
          data-testid="chat-input-textarea"
          rows="1"
          cols="30"
          name="qiraQuestion"
          class="mt-2 w-full !bg-white"
          placeholder=""
          [(ngModel)]="message"
          [disabled]="true"></textarea>

        <div class="flex items-start justify-start">
          <div class="mt-4 flex flex-1 flex-wrap items-center justify-start gap-2">
            <p class="ml-2 whitespace-nowrap font-bold">
              {{ 'chatMessages.filter.headline' | transloco: { count: filteredGroups().length } }}
            </p>
            <p>-</p>
            <app-smart-search-filter [(selectedDocumentTypes)]="selectedDocumentTypes" [(selectedProviders)]="selectedProviders" class="flex-1" />
          </div>
        </div>

        <div class="mt-6">
          <app-smart-search
            [content]="messages"
            [tabId]="tabId"
            [filter]="{ provider: selectedProviders(), subject: selectedDocumentTypes() }"
            [showCitedTag]="true"
            (onFilter)="filteredGroups.set($event)"
            class="mb-4 block" />
        </div>
      </div>
      <!-- End scroll content -->
    </div>
  </div>
</div>
